import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="cta-section"
      className="bg-slate-900 py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
          className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8"
        >
          <div className="max-w-2xl">
            <h2
              data-testid="cta-heading"
              className="text-2xl md:text-3xl font-semibold tracking-tight text-white font-['Manrope'] mb-3"
            >
              Ready to structure your inbound workflows?
            </h2>
            <p className="text-base text-slate-400 leading-relaxed">
              If your team handles high-volume requests or processes that need better visibility and control, let's discuss how Pyrtex can help.
            </p>
          </div>
          <div className="flex-shrink-0">
            <Button
              onClick={scrollToContact}
              data-testid="cta-button"
              className="bg-white text-slate-900 hover:bg-slate-100 text-xs tracking-wide font-semibold px-8 py-6 rounded-sm"
            >
              Request a Consultation
              <ArrowRight className="ml-2" size={16} strokeWidth={1.5} />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
